/* eslint-disable jsx-a11y/anchor-is-valid */
//@ts-nocheck
import React, {FC, forwardRef, useEffect, useState} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {useIntl} from 'react-intl'
import {ID} from '../../../../../../_metronic/helpers'
import {useListView} from '../../../core/ListViewProvider'
import {useQueryResponse} from '../../../core/QueryResponseProvider'
import Swal from 'sweetalert2'
import {deleteTask, updateStatusTask} from '../../../core/_requests'
import {deliveryTask, deliveryTaskPartial, reopenTaskMyPart} from '../../../core/_requests'
import {Dropdown} from 'react-bootstrap'
import {Toast} from '../../../../../../_metronic/partials/widgets'
import {TaskCloneModal} from '../../../../project/components/tasks-list/task-clone-modal/TaskCloneModal'
import {AdjustTimeUserModal} from '../../../../../../_metronic/partials/modals/adjust-time-user/AdjustTimeUserModal'
import {DeliveryOptionsModal} from '../../../../../../_metronic/partials/modals/task-delivery/DeliveryOptionsModal'
import {useSearchParams} from 'react-router-dom'
import {useAuth, UserModel} from '../../../../auth'
import {useCanDeleteTask} from '../../../../config/hooks/useCanDeleteTask'
import {useDropdownOpen} from '../../../../../../_metronic/context/DropdownOpenProvider'
import {invalidateAfterTaskChange} from '../../../../../../_metronic/helpers/taskQueryInvalidation'

type Props = {
  taskId: ID
  name: string
  status: string
  play: string
  sequenceResponsibles?: UserModel[]
  users?: Array<{user_id?: number; id?: number; task_concluded?: number; pivot?: {concluded?: number}; [key: string]: unknown}>
  subtasksCount?: number
  creatorId?: string | number
}

export type CustomToggleProps = {
  children: React.ReactNode
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {}
}

const MyTaskActionsCell: FC<Props> = ({
  taskId,
  name,
  status,
  play,
  sequenceResponsibles = [],
  users = [],
  subtasksCount = 0,
  creatorId,
}) => {
  const intl = useIntl()
  const {currentUser, setCurrentUser} = useAuth()
  const {setItemIdForUpdate} = useListView()
  const {setDropdownOpenTaskId} = useDropdownOpen()
  const queryClient = useQueryClient()
  const {refetch} = useQueryResponse()
  const {canDelete} = useCanDeleteTask({ creator_id: creatorId })
  const hasSequence = !!(sequenceResponsibles && sequenceResponsibles.length > 0)
  const myPartConcluded =
    !hasSequence &&
    status?.toLowerCase() !== 'entregue' &&
    !!currentUser?.id &&
    (users as Array<{user_id?: number; id?: number; task_concluded?: number; pivot?: {concluded?: number}}>).some(
      (u) =>
        Number(u.user_id ?? u.id) === Number(currentUser.id) &&
        Number(u.task_concluded ?? u.pivot?.concluded ?? 0) === 1
    )
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalClone, setShowModalClone] = useState<boolean>(false)
  const [showAdjustTimeModal, setShowAdjustTimeModal] = useState<boolean>(false)
  const [showDeliveryModal, setShowDeliveryModal] = useState<boolean>(false)
  const TemaAtual = window.localStorage.getItem('kt_theme_mode_value') || ''
  const [action, setAction] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [taskByIdURL, setTaskByIdURL] = useState<ID>()
  const [selectedResponsibleId, setSelectedResponsibleId] = useState<number>()

  const openEditModal = (taskIdParam: ID) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('taskId', taskId!.toString()!)
    setSearchParams(newParams)
    setItemIdForUpdate(taskIdParam)
    setTaskByIdURL(taskIdParam)
    setShowModal(true)
    setAction(true)
  }

  const openCloneTask = () => {
    setItemIdForUpdate(taskId!)
    setShowModalClone(true)
  }

  const openTask = async () => {
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    const theme = CurrentTheme === 'dark' ? '#353b48' : '#fff'

    const optionsHtml = sequenceResponsibles
      .map(
        (option, index) =>
          `<option index="${index}" value="${option.id}" data-order="${option.pivot.order}">${option.name}</option>`
      )
      .join('')

    sequenceResponsibles.length > 0
      ? Swal.fire({
          title: 'Confirmação de Reabertura de Tarefa',
          html: `
            <p class='mb-6'>Esta tarefa possui sequência de responsáveis. Por favor, selecione o usuário para quem a tarefa será reaberta.</p>
            <div class='text-start'>
              <label class='fs-6 fw-semibold form-label mb-2'>
                Escolha o responsável para reabrir a tarefa:
              </label>
              <select 
                id="sequenceResponsiblesSelect" 
                class='form-select form-select-sm form-select-solid'
                value='${selectedResponsibleId}'>
                ${optionsHtml}
              </select>
            </div>
          `,
          icon: 'warning',
          background: theme,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Reabrir tarefa',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          preConfirm: () => {
            const select = document.getElementById('sequenceResponsiblesSelect')
            const selectedOption = select.options[select.selectedIndex]

            return {
              id: selectedOption.value,
              order: selectedOption.dataset.order,
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            updateStatusTask(taskId, 'Backlog', result.value.id, result.value.order)
              .then((response) => {
                Toast.fire({
                  icon: 'success',
                  title: intl.formatMessage(
                    {id: 'ALERT.LABEL.SUCCESS_TASK_OPEN_ITEM'},
                    {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
                  ),
                  customClass: {
                    popup: 'bg-light-success',
                    title: 'text-success',
                  },
                })

                invalidateAfterTaskChange(queryClient, {
                  refreshSession: !!currentUser?.has_active_time_tracking,
                })
                // Invalidar especificamente as queries do calendário
                queryClient.invalidateQueries(['calendar-tasks'])
                cancel(true)
              })
              .catch((e) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Erro',
                  html: '<h5>' + e.response?.data.message + '</h5>',
                  background: theme,
                  confirmButtonColor: '#009ef7',
                  color: '#fff',
                })
              })
          }
        })
      : updateStatusTask(taskId, 'Backlog')
          .then(() => {
            invalidateAfterTaskChange(queryClient, {
              refreshSession: !!currentUser?.has_active_time_tracking,
            })
            // Invalidar especificamente as queries do calendário
            queryClient.invalidateQueries(['calendar-tasks'])
            cancel(true)
          })
          .catch((e) => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              html: '<h5>' + e.response?.data.message + '</h5>',
              background: theme,
              confirmButtonColor: '#009ef7',
              color: '#fff',
            })
          })
  }

  const entregatask = async () => {
    if (sequenceResponsibles.length > 0) {
      const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
      const tema = CurrentTheme === 'dark' ? '#353b48' : '#fff'
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: intl.formatMessage({id: 'ALERT.TITLE.TASK.DELIVERY'}),
          icon: 'warning',
          text: 'Esta tarefa possui outros membros na sequência. Ao entregar, ela será transferida para o próximo responsável. Deseja entregar sua parte?',
          background: tema,
          showCancelButton: true,
          confirmButtonText: 'Sim, entregar minha parte',
          cancelButtonText: 'Não',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) deliveryItem.mutate()
          else if (result.dismiss === Swal.DismissReason.cancel) {
            Toast.fire({
              icon: 'warning',
              title: intl.formatMessage(
                {id: 'ALERT.LABEL.ERROR_TASK_CLOSE_ITEM'},
                {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
              ),
              customClass: { popup: 'bg-light-danger', title: 'text-danger' },
            })
          }
        })
      return
    }
    const count = Array.isArray(users) ? users.length : 0
    if (count > 1) {
      setShowDeliveryModal(true)
      return
    }
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    const tema = CurrentTheme === 'dark' ? '#353b48' : '#fff'
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false,
    })
    swalWithBootstrapButtons
      .fire({
        title: intl.formatMessage({id: 'ALERT.TITLE.TASK.DELIVERY'}),
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) deliveryItem.mutate()
        else if (result.dismiss === Swal.DismissReason.cancel) {
          Toast.fire({
            icon: 'warning',
            title: intl.formatMessage(
              {id: 'ALERT.LABEL.ERROR_TASK_CLOSE_ITEM'},
              {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
            ),
            customClass: { popup: 'bg-light-danger', title: 'text-danger' },
          })
        }
      })
  }

  const deleta = async () => {
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    let tema = ''
    if (CurrentTheme === 'dark') {
      tema = '#353b48'
    } else {
      tema = '#fff'
    }

    // Verificar se a tarefa possui subtarefas usando os dados já disponíveis
    if (subtasksCount > 0) {
      // Modal informativo se houver subtarefas
      Swal.fire({
        title: 'Não é possível excluir esta tarefa',
        html: `
          <div class="text-start">
            <p class="mb-4">Esta tarefa possui <strong>${subtasksCount} subtarefa(s) vinculada(s)</strong> e não pode ser excluída diretamente.</p>
            <p class="mb-3">Para excluir esta tarefa, você precisa:</p>
            <ul class="text-start mb-4">
              <li><strong>Desvincular as subtarefas</strong> da tarefa principal, ou</li>
              <li><strong>Excluir as subtarefas</strong> primeiro</li>
            </ul>
            <p class="mb-0 text-muted">Acesse a tarefa para gerenciar suas subtarefas antes de tentar excluí-la novamente.</p>
          </div>
        `,
        icon: 'warning',
        background: tema,
        showCloseButton: true,
        confirmButtonText: 'Entendi',
        confirmButtonColor: '#009ef7',
        width: 500,
      })
      return
    }

    // Modal de confirmação normal se não houver subtarefas
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    })

    swalWithBootstrapButtons
      .fire({
        title: intl.formatMessage({id: 'ALERT.LABEL.ARE_YOU_SURE'}),
        html: 'Tem certeza de que deseja deletar essa tarefa? Atenção: se houver horas lançadas ou outras pessoas vinculadas a ela, isso pode impactar o controle de tempo e os custos do projeto.',
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim, pode excluir',
        cancelButtonText: 'Não, cancele!',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteItem.mutate()
        }
      })
  }

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const onDeliverySuccess = (response: {status?: string; message?: string}) => {
    Toast.fire({
      icon: response.status === 'success' ? 'success' : 'error',
      title: response.message || '',
      customClass: {
        popup: response.status === 'success' ? 'bg-light-success' : 'bg-light-danger',
        title: TemaAtual === 'dark' ? 'text-dark' : 'text-success',
      },
    })
    if (play === 'run')
      setCurrentUser((user) => ({...user, has_active_time_tracking: false} as UserModel))
    cancel(true)
    invalidateAfterTaskChange(queryClient, {
      refreshSession: !!currentUser?.has_active_time_tracking,
    })
    queryClient.invalidateQueries(['calendar-tasks'])
  }

  const deliveryItem = useMutation(() => deliveryTask(taskId), {
    onSuccess: onDeliverySuccess,
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const deliveryPartialItem = useMutation(() => deliveryTaskPartial(taskId), {
    onSuccess: onDeliverySuccess,
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const reopenItem = useMutation(() => reopenTaskMyPart(taskId), {
    onSuccess: (response: {status?: string; message?: string}) => {
      Toast.fire({
        icon: response.status === 'success' ? 'success' : 'error',
        title: response.message || 'Sua parte foi reaberta.',
        customClass: {
          popup: response.status === 'success' ? 'bg-light-success' : 'bg-light-error',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-success',
        },
      })
      cancel(true)
      invalidateAfterTaskChange(queryClient, {
        refreshSession: !!currentUser?.has_active_time_tracking,
      })
      queryClient.invalidateQueries(['calendar-tasks'])
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const deleteItem = useMutation(() => deleteTask(taskId), {
    onSuccess: () => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TASK_DELETE_ITEM'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })

      // Limpar taskId da URL para evitar redirecionamento para tarefa inexistente
      const newParams = new URLSearchParams(searchParams)
      newParams.delete('taskId')
      setSearchParams(newParams)

      cancel(true)
      invalidateAfterTaskChange(queryClient, {
        refreshSession: !!currentUser?.has_active_time_tracking,
      })
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])
    },
    onError: (error) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: 'text-danger',
        },
      })
    },
  })

  const CustomToggle = forwardRef((props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <a
      href=''
      className='text-hover-primary'
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        props.onClick(e)
      }}
    >
      {props.children}
    </a>
  ))

  return (
    <>
      {name !== '' && (
        <div
          className='text-center'
          style={{display: 'flex', gap: '20px', justifyContent: 'center'}}
        >
          <button
            className='btn btn-icon-dark btn-active-icon-primary btn-active-text-primary p-0'
            onClick={() => openEditModal(taskId)}
          >
            <i className='bi bi-eye-fill fs-3'></i>
          </button>

          <Dropdown
            onToggle={(nextShow) => setDropdownOpenTaskId(nextShow ? Number(taskId) : null)}
          >
            <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
              <i className='bi bi-list-ul fs-3 text-dark'></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={(e) => {
                  e.preventDefault()
                  setShowAdjustTimeModal(true)
                }}
                eventKey='2'
              >
                {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.ADJUST_TIMETRACKING'})}
              </Dropdown.Item>
              {status.toLowerCase() === 'entregue' ? (
                <Dropdown.Item onClick={openTask} eventKey='4'>
                  {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.OPEN_TASK'})}
                </Dropdown.Item>
              ) : myPartConcluded ? (
                <Dropdown.Item onClick={() => reopenItem.mutate()} eventKey='4'>
                  Reabrir minha parte
                </Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={entregatask} eventKey='4'>
                  {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.FINIS_TASK'})}
                </Dropdown.Item>
              )}

              {!currentUser?.external_user && (
                <>
                  <Dropdown.Item onClick={openCloneTask} eventKey='5'>
                    {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.CLONE_TASK'})}
                  </Dropdown.Item>
                  {canDelete && (
                    <Dropdown.Item onClick={deleta} eventKey='6'>
                      {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.DELETE'})}
                    </Dropdown.Item>
                  )}
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      <TaskCloneModal
        show={showModalClone}
        handleClose={() => setShowModalClone(false)}
        taskId={taskId}
      />
      {/* 
            //@ts-ignore */}
      <AdjustTimeUserModal
        show={showAdjustTimeModal}
        handleClose={() => setShowAdjustTimeModal(false)}
        taskId={taskId!}
      />
      <DeliveryOptionsModal
        show={showDeliveryModal}
        onClose={() => setShowDeliveryModal(false)}
        onDeliverFull={() => deliveryItem.mutate()}
        onDeliverPartial={() => deliveryPartialItem.mutate()}
        taskName={name}
      />
    </>
  )
}

export {MyTaskActionsCell}
